export default __webpack_public_path__ + "static/media/profile-user (2)1.7ca6b813.png";